const routes = {
  getAllAuditLogs: 'audit-logs',
};

export default routes;
